import React from 'react';
import { callCouponSvc, CouponBanner, generateUniqueCoupon, getAvailableVouchers } from './utils/vGenerator';
import { COUPON_ITEM_KEY } from './constants';
import { FormInput } from './components/formInput';
import { FormButton } from './components/formButton';
import { ScreenContainer } from './App';
import { buying_options } from './Home';
import CryptoJS from 'crypto-js';
import { validateEmail } from './NewCurriculum';

const SHARED_KEY = 'noisycheese990'; // Replace with your actual shared key

const encodeTimestamp = (timestamp) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(timestamp.toString()));
  };
  
  // Function to generate the license code
  const generateLicenseCode = () => {
    const timestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds
    const encodedTimestamp = encodeTimestamp(timestamp); // Obfuscated timestamp
  
    // Generate hash using the encoded timestamp
    const hash = CryptoJS.HmacSHA256(encodedTimestamp, SHARED_KEY)
      .toString(CryptoJS.enc.Base64)
      .slice(0, 16); // Shortened hash
  
    // Return the license code in the format: hash:encodedTimestamp
    return `${hash}:${encodedTimestamp}`;
  };
  
  


export const CodeGenerator = () => {

    const [email, setEmail] = React.useState('')
    const [code, setCode] = React.useState('')
    const [loading, setLoading] = React.useState(false)
   
   

    return(<div>
        <ScreenContainer title='Get Your License Code to Unlock The App For Life'>
      
        <div className='fs-6 pb-2  p-10'>
            
            <FormInput text={email} placeholder='Enter your email' onTextChange={t => setEmail(t)}
            />

            <FormButton label='Generate' onClick={() => {

                if(!email?.length || !validateEmail(email)) {
                    alert('Invalid email');
                    return;
                }

               const c =  generateLicenseCode(email)
               alert(c)
               setCode(c)
            }}
            />
        </div>

            <div className='pb-10'>
               {
                code?.length ? <div>
                  <div
  className="p-4 bg-gray-100 rounded text-sm w-full overflow-x-auto font-mono whitespace-pre-wrap"
>
  {code}
</div>

                </div>
                : null
               }
            </div>
    
        </ScreenContainer>
    </div>
)
}